import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { Voucher, VoucherQueryParams, VoucherCode, VoucherCodeQueryParams, User } from "../types";

interface VoucherState {
	vouchers: Array<Voucher>;
	vouchersTotal: number;
	voucher?: Voucher;
	voucherCodes?: Array<VoucherCode>;
	voucherCodesTotal?: number;
}

const initialState: VoucherState = {
	vouchers: [],
	vouchersTotal: 0,
};

export const voucherSlice = createSlice({
	name: "voucher",
	initialState,
	reducers: {
		setVouchers: (state, action) => {
			state.vouchers = action.payload.data;
			state.vouchersTotal = action.payload.total;
		},
		setVoucher: (state, action) => {
			state.voucher = action.payload.data;
		},
		changeStatusVoucher: (state, action) => {
			const { id, status } = action.payload;
			const index = state.vouchers.findIndex(el => el._id === id);
			state.vouchers[index].status = status;
		},
		setVoucherCodes: (state, action) => {
			state.voucherCodes = action.payload.data;
			state.voucherCodesTotal = action.payload.total;
		},
	},
});

export const selectVouchers = (state: RootState) => state.voucher.vouchers;
export const selectVouchersTotal = (state: RootState) =>
	state.voucher.vouchersTotal;
export const selectVoucher = (state: RootState) => state.voucher.voucher;
export const selectVoucherCodes = (state: RootState) => state.voucher.voucherCodes;
export const selectVoucherCodesTotal = (state: RootState) =>
	state.voucher.voucherCodesTotal;

export const {
	setVouchers,
	setVoucher,
	changeStatusVoucher,
	setVoucherCodes
} = voucherSlice.actions;

export interface GetVouchersAsyncPayload {
	query: VoucherQueryParams;
	callback?: () => void;
}
export interface GetVoucherCodesAsyncPayload {
	id: string;
	query: VoucherCodeQueryParams;
	willNotUpdate?: boolean;
	callback?: (codes: VoucherCode[]) => void;
}
export interface GetVoucherDetailsPayload {
	id: string;
	callback?: (data?: Voucher) => void;
}

export interface CreateVoucherPayload {
	voucher?: Voucher;
	callback?: (data: Voucher) => void;
}

export interface UpdateVoucherPayload {
	id?: string;
	status?: string;
	rejectReason?: {
		message: string,
	};
	callback?: (data?: Voucher) => void;
}

export interface SendToCustomerPayload {
	id: string;
	users: Array<User>;
	callback?: () => void;
	errorCallback?: () => void;
}

export const getVouchersAsync = createAction(
	"voucher/getVouchers",
	(payload: GetVouchersAsyncPayload) => ({
		payload: payload || {},
	}),
);

export const getVoucherDetailsAsync = createAction(
	"voucher/getVoucherDetails",
	(payload: GetVoucherDetailsPayload) => ({
		payload: payload,
	}),
);

export const createVoucherAsync = createAction(
	"voucher/createVoucher",
	(payload: CreateVoucherPayload) => ({
		payload: payload,
	}),
);


export const updateVoucherAsync = createAction(
	"voucher/updateVoucher",
	(payload: UpdateVoucherPayload) => ({
		payload: payload,
	}),
);

export const getVoucherCodesAsync = createAction(
	"voucher/getVoucherCodes",
	(payload: GetVoucherCodesAsyncPayload) => ({
		payload: payload || {},
	}),
);

export const sendToCustomerAsync = createAction(
	"voucher/sendToCustomerAsync",
	(payload: SendToCustomerPayload) => ({
		payload: payload || {},
	}),
);

export default voucherSlice.reducer;
